module.exports = __webpack_public_path__ + "static/media/additionalDetails.e744b0d6.svg";